/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */

import BreadCrumbsComponent from "../SharedComponents/BreadCrumbs/BreadCrumbsComponent";
import Title from "../SharedComponents/Title/Title";
import { useEffect, useState } from "react";

import "./SetupTenantPage.scss";
import CreateTenant from "./createTenantDetails/CreateTenant";
import { SettingsPage } from "./settingPage/SettingsPage";
import { StepperDTO } from "../../models/componentModels/StepperDTO";
import { Card, Stepper } from "@forge/common";
import { Summary } from "./summary/Summary";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { getStepperbyStatus } from "./WrapperSetupTenant";
import { StatusCode } from "../../models/apiModels/Tenant";
import CreateEditTenantonBack from "./createTenantDetails/createEditTenantonBack";
import { localeKeyMap } from '../../localization/keys';
import { useTranslation } from "@scuf/localization";

function SetupTenantPage() {
  const [t] = useTranslation();

  const initialStepperState: StepperDTO = {
    currentStep: "undefined",
    steps: [
      {
        id: "CreateTenant",
        status: undefined,
        title: t(localeKeyMap.enterTenantDetails),
      },
      {
        id: "Settings",
        status: undefined,
        title: t(localeKeyMap.addParameters),
      },
      {
        id: "Summary",
        status: undefined,
        title: t(localeKeyMap.summary),
      },
    ],
  };

  const [stepperState, setStepperState] =
    useState<StepperDTO>(initialStepperState);
  const [crumbs, setCrumbs] = useState([
    {
      id: "create-tenant",
      label: t(localeKeyMap.setupTenant),
    },
  ]);

  const tenantStatus = useSelector(
    (state: RootState) => state.cart.tenantDeatailsByTenantId?.status
  );
  useEffect(() => {
    const newStepper: StepperDTO = getStepperbyStatus(
      tenantStatus ?? StatusCode.Invalid
    );

    setStepperState(newStepper);
  }, [tenantStatus]);

  return (
    <>
      <BreadCrumbsComponent crumbs={crumbs} backbutton={false} />
      <Title title={t(localeKeyMap.setupTenant)} className="p-t15 p-b20" />
      {/* CID 3289795 */}
      {stepperState &&
        (stepperState.currentStep === "CreateTenant" ||
          stepperState.currentStep === "Settings" ||
          stepperState.currentStep === "Summary" ||
          stepperState.currentStep === "EditTenantBack") && (
          <Card
            style={{ marginBottom: "50px" }}
            className="p-15 border-gray border-radius-10 create_tenant"
          >
            <div>
              <Stepper
                currentStep={stepperState.currentStep}
                orientation="horizontal"
                steps={stepperState.steps.map((step) => ({
                  id: step.id,
                  status: step.status,
                  title: step.title,
                }))}
              />
            </div>

            <div className="d-flex main_form_wrap">
              {stepperState?.currentStep === "Settings" && (
                <SettingsPage
                  stepperState={stepperState}
                  setStepperState={setStepperState}
                />
              )}
              {stepperState?.currentStep === "EditTenantBack" &&
                (tenantStatus === StatusCode.InProgress ||
                  tenantStatus === StatusCode.InIt) && (
                  <CreateEditTenantonBack
                    stepperState={stepperState}
                    setStepperState={setStepperState}
                  />
                )}

              {stepperState?.currentStep === "CreateTenant" &&
                (tenantStatus === StatusCode.Invalid ||
                  tenantStatus === StatusCode.noTenant) && (
                  <CreateTenant
                    stepperState={stepperState}
                    setStepperState={setStepperState}
                  />
                )}
              {stepperState?.currentStep === "Summary" && (
                <Summary
                  stepperState={stepperState}
                  setStepperState={setStepperState}
                />
              )}
            </div>
          </Card>
        )}
    </>
  );
}

export default SetupTenantPage;